const isPlural = ({ one, more, number }: { one: string; more: string; number: number }) => {
  if (number === 0 || number > 1) return more;

  return one;
};

export default isPlural;
